import React, { useEffect, useState, useMemo } from "react";
import { ReactComponent as BackChevron } from "@assets/images/backChevron.svg";
import style from "./splitBySeat.module.scss";
import cn from "classnames";
import { CUSTOM_MESSAGES, LABEL } from "../../../veriables";
import { findIndex } from "lodash";
import { COUNTRY_CODE } from "@constants";
import { getObjectValue } from "@utility/utills";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { setSeat, removeWithPaymentStages } from '@reducers/orders';
import { setNotification } from '@reducers/notification';
import KeyboardForOrder from '@components/OrderMenuTopScreen/keyboardForOrderMenuCopy'
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import { ReactComponent as Edit } from "@assets/images/edit/edit.svg";
import { TouchableButton, TouchableDiv } from '@components/common/Touchable'
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import ModalHeader from "../../common/ModalHeader/index";
import NotesIcon from '@assets/images/NotesIcon';
import { ReactComponent as DeleteIcon } from "@assets/images/delete.svg";
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const SplitBySeat = ({
    seat,
    serverAppTheme,
    seatItemHashTable,
    tableData,
    setTableData,
    selectedStage,
    selectedItem,
    selectedSeats,
    setSelectedStage,
    handleCheckItems,
    handleBackButtonClick,
    handleOpenEditModal,
    handleOpenDeleteModal,
    handleStagePaymentSubmit,
    deviceInfo,
    handleStageSelection,
    handleCheckAllItems,
    handleStageMove,
    isOrderingPortrait,
    ...props
}) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState({ isEditOpen: false, data: {} });
    const countryCode = getObjectValue(
        () => COUNTRY_CODE[props.auth.country].dialCode,
        "1",
    );
    const currencySymbol = LABEL().CURRENCY_SYMBOL;
    const getTotalAmount = (amount) => {
        return Number(amount) > 0 ? Number(amount) : 0;
    };

    let priorTotalAmount = 0;
    const paymentStageItemsArrayWithSplitValue = [];
    const isAllSeatsStaged = (() => {
        const seatIds = seat.seats.reduce((a, v) => {
            if (v.open) {
                a.push(v.id);
            }
            return a;
        }, []);
        const paymentStagesSeats = seat?.splits.reduce((a, v) => {
            if (v.status === 0 && v?.seats?.length > 0) {
                v.seats.forEach(({ seatId }) => a.push(seatId));
            }
            return a;
        }, []);
        return paymentStagesSeats.length === seatIds.length;
    })();

    seat?.splits
        ?.filter((el) => el.splitType !== 0)
        ?.forEach((splitsData, i) => {
            const itemsArray = [];
            let subTotalAmount = 0;
            let serviceChargeAmount = 0;
            let discountAmount = 0;
            seat?.items?.forEach((it) => {
                let price = 0;
                let flag = false;
                let count = 0;
                splitsData.seats.forEach((nSeat) => {
                    const index = findIndex(it.seats, (d) => d.seatId === nSeat.seatId);
                    if (index !== -1) {
                        flag = true;
                        count += 1;
                        price += it.seats[index].splitAmount;
                    }
                });
                if (flag) {
                    subTotalAmount += price;
                    itemsArray.push({
                        ...it,
                        isCheck: false,
                        oldPrice: it.price,
                        price,
                        splitValueString:
                            count === it.seats.length ? "" : `${count}/${it.seats.length} `,
                        splitValue: count === it.seats.length ? 1 : count + 1,
                    });
                }
            });
            paymentStageItemsArrayWithSplitValue.push(itemsArray);
            seat?.serviceCharges?.forEach((serviceCharge) => {
                let serviceChargeValue = 0;
                let flag = false;
                splitsData.seats.forEach((nSeat) => {
                    const index = findIndex(
                        serviceCharge.seats,
                        (d) => d.seatId === nSeat.seatId,
                    );
                    if (index !== -1) {
                        flag = true;
                        serviceChargeValue += serviceCharge.seats[index].splitAmount;
                        itemsArray.push({
                            ...serviceCharge,
                            menuItemName: serviceCharge.serviceChargeName,
                            price: serviceCharge.seats[index].splitAmount,
                            service: true,
                        });
                    }
                });
                if (flag) {
                    serviceChargeAmount += serviceChargeValue;
                }
            });

            seat?.discounts?.forEach((discount) => {
                let discountValue = 0;
                let flag = false;
                splitsData.seats.forEach((nSeat) => {
                    const index = findIndex(
                        discount.seats,
                        (d) => d.seatId === nSeat.seatId,
                    );
                    if (index !== -1) {
                        flag = true;
                        discountValue += discount.seats[index].splitAmount;
                        itemsArray.push({
                            ...discount,
                            menuItemName: discount.discountName,
                            price: discount.seats[index].splitAmount,
                            discount: true,
                        });
                    }
                });
                if (flag) {
                    discountAmount += discountValue;
                }
            });
            const taxAmt = +((subTotalAmount * seat?.taxAmount) / seat?.itemAmount);
            const lastStageTaxAmount = +(
                seat?.unpaidAmount -
                priorTotalAmount -
                subTotalAmount +
                discountAmount
            );
            const taxAmount =
                isAllSeatsStaged &&
                    i === seat?.splits.length - 1 &&
                    lastStageTaxAmount > 0
                    ? +lastStageTaxAmount
                    : +taxAmt;
            const totalAmount =
                countryCode === "44"
                    ? getTotalAmount(
                        +(subTotalAmount + serviceChargeAmount - discountAmount),
                    )
                    : getTotalAmount(
                        +(
                            taxAmount +
                            subTotalAmount +
                            serviceChargeAmount -
                            discountAmount
                        ),
                    );
            if (splitsData.status === 0) {
                priorTotalAmount += totalAmount;
            }
            seatItemHashTable[splitsData.id] = {
                paymentStageId: splitsData.id,
                items: itemsArray,
                taxAmount,
                subTotalAmount,
                ...splitsData,
                totalAmount,
                unpaidAmount: +(
                    taxAmount +
                    subTotalAmount +
                    serviceChargeAmount -
                    discountAmount
                ).toFixed(2),
                paidAmount: 0,
                serviceChargeAmount: +serviceChargeAmount.toFixed(2),
                discountAmount: +discountAmount.toFixed(2),
            };
        });

    const newItemsStyle = useMemo(() => {
        const sentItemsStyle = {
            //backgroundColor: serverAppTheme?.selectedCheck_bg,
            border: serverAppTheme?.select_border,
            color: serverAppTheme?.primary_text,
            borderRadius: '4px'
        }
        return {
            sentItemsStyle
        }
    }, [serverAppTheme])

    useEffect(() => {
        setTableData({
            splits: seatItemHashTable,
            seats: seat?.seats?.reduce((a, v) => {
                a.push(v);
                return a;
            }, []),
            stageItemsArray: paymentStageItemsArrayWithSplitValue.flat(1),
        });
        setSelectedStage(
            seat?.splits?.find((e) => e?.status === 0 && e?.splitType !== 0)?.id,
        );
    }, [seat]);

    const getEditedTableName = (splitId) => {
        const splitsArr = seat?.splits || [];

        const seatData = splitsArr && Object.values(splitsArr);

        const requiredSplit = seatData?.find((el) => el.id === splitId);

        return requiredSplit?.name || null;
    };

    const handlePayment = (isCross) => {
        const splits = seat?.splits || [];
        const splitsToSend = splits
            ?.filter((e) => e?.status === 0 && e?.splitType !== 0)
            ?.map((el) => {
                const seatsToSend = [el?.seats[0]?.seatId];
                const checkSplitId = String(el?.id)?.includes("id") ? null : el?.id;
                const matchedSeat = tableData.seats.find(seat => seat.id === el?.seats[0]?.seatId);
                const loyaltyId = matchedSeat?.loyalty?.id || null;
                return {
                    checkSplitId: checkSplitId,
                    name: getEditedTableName(el?.id),
                    seatIds: seatsToSend,
                    checkLoyaltyId: loyaltyId,
                };
            });
        const payload = {
            storeId: deviceInfo?.storeId,
            deviceId: deviceInfo?.deviceId,
            employeeId: seat?.employeeId,
            employeeCard: null,
            checkHeaderId: seat?.id,
            splitType: 1,
            splits: splitsToSend,
        };
        handleStagePaymentSubmit({ payload, isCross });
    };

    const shwMove = () => {
        return getObjectValue(
            () =>
                tableData?.splits[selectedStage]?.items?.filter((e) => e.isCheck)
                    .length > 0,
            false,
        );
    };
    const renderModifier = (modifiersObj, n, nest) => (
        <ul className={cn('pl-0 m-0 fs_12 list-unstyled col-12 pr-0')}>
            {modifiersObj?.map((modifier, index) => {
                return (
                    <li className={cn('col-12 px-0 w-99', modifier?.price === 0 && 'd-none')} style={{ color: nest ? serverAppTheme?.primary_text : '#5081DE' }} key={modifier?.modifierId}>
                        <div className={cn('col-12 mt-1 mx-0 px-0 row w-99', !(nest && index === 1) && 'mt-1')}>{modifier?.quantity > 1 && (<span className="col-1 px-0 mt-1 m-0 va-tt"><u>{modifier?.quantity}</u>  <span>x</span> </span>)}
                            <div className={cn(modifier?.quantity > 1 ? 'col-9' : 'col-10' ,isOrderingPortrait ? 'pl-4 pr-0' : 'px-0')}>
                                {modifier?.modifierName}
                            </div>
                            {modifier?.price && (
                                <div className="text-right col-2 px-0">
                                    {LABEL().CURRENCY_SYMBOL}
                                    {modifier?.price?.toFixed(2)}
                                </div>
                            )}
                        </div>
                        {(modifier.note || modifier.comment) && (
                            <div className={cn("col-12 row mx-0 px-0 fs-12")}>
                                <span className='col-1 px-0'>
                                    <NotesIcon />
                                </span>
                                <span className={cn('pl-2 col-11 pr-0')} style={{color: "#000"}}>
                                    {modifier.note || modifier.comment}
                                </span>
                            </div>
                        )}
                        {modifier?.modifiers && modifier?.modifiers?.length > 0 && (
                            <div className='d-flex col-12 px-0 w-95'>
                                <div className={cn('fs_20', style.hyphenStyle)} style={{ color: serverAppTheme?.modifier_arrowDown }}>-</div>
                                <div className='col-12 px-0 pl-1 mt-1 fs_10'>
                                    {renderModifier(modifier?.modifiers, n, true)}
                                </div>
                            </div>
                        )}
                    </li>
                );
            })}
        </ul>
    );
    const ItemList = (items) => { 
        return items.length > 0 ? (
            items.map((i, index) => {  
             const isGiftCardSplit =  props.menuItemsHashTable[i?.menuItemId]?.cardType ===2;     
                return (
                    <div
                        className={cn(
                            "col-12 rounded row m-0 fs_16 fw-500 px-0 py-2 px-2 mb-1",
                            [selectedItem].some((e) => e.id === i.id)
                                ? "od-container-app-background  background-primary"
                                : "od-container-card-border border-color-primary",
                        )}
                        style={{
                            backgroundColor: [selectedItem].some((e) => e.id === i.id)
                                ? serverAppTheme?.selectedCheck_bg
                                : serverAppTheme?.send_tab_unselected,
                        }}
                    >
                        <TouchableDiv className="col-1 p-0 d-flex align-items-center">
                            {!isGiftCardSplit &&
                            <input
                                type="checkbox"
                                id={i.id}
                                onChange={() => { }}
                                className={cn(isOrderingPortrait ? style.portaritcheckbox : style.checkbox)}
                                style={{
                                    border: i?.isCheck ? "none" : serverAppTheme?.checkbox_border,
                                    "--checkbox-checked-color":
                                        serverAppTheme?.checkbox_check_color,
                                    '--checkbox-checked-bg': serverAppTheme?.checkbox_checked
                                }}
                                onClick={(e) => handleCheckItems(i, e.target.checked, index)}
                                checked={i?.isCheck || false}
                            /> }
                        </TouchableDiv>
                        <TouchableDiv
                            className="col-11 row m-0 p-0"
                            role="button"
                            tabIndex="0"
                            onClick={() => !isGiftCardSplit && handleCheckItems(i, !i?.isCheck, index)}
                        >
                            <div className={cn("col-7 pl-2 pr-0 d-flex align-items-center",isOrderingPortrait ? 'fs_12 fw-400' : '')}>
                                {i.menuItemName}
                            </div>
                            <div className={cn("col-1 pl-2 px-0 d-flex align-items-center justify-content-center",isOrderingPortrait ? 'fs_12 fw-400' : '')}>
                                {i.seats &&
                                    i.seats.length > 0 &&
                                    i.seats[0].splitValue > 1 &&
                                    i.quantity
                                    ? `${i.quantity}/${i.seats[0].splitValue}`
                                    : i.quantity}
                            </div>
                            <div className={cn("col-4 px-0 text-right d-flex align-items-center justify-content-end",isOrderingPortrait ? 'fs_12 fw-400' : '')}>
                                {i?.discountId ? (
                                    <>
                                        -{currencySymbol}
                                        {i?.value?.toFixed(2) || i?.price?.toFixed(2)}
                                    </>
                                ) : (
                                    <>
                                        {currencySymbol}
                                        {i?.value?.toFixed(2) || i?.price?.toFixed(2)}
                                    </>
                                )}
                            </div>
                        </TouchableDiv>
                         <div
                                className={cn("col-12 px-0")}
                                role="presentation"
                            >
                                {i.modifiers &&
                                    i.modifiers.length > 0 &&
                                    renderModifier(i.modifiers, 0)}
                                {(i.note || i.comment) && (
                                    <div style={{ color: serverAppTheme?.noteColor }} className={cn("col-12 row mx-0 px-0 fs-12")}>
                                        <span className='col-1 px-0'>
                                            <NotesIcon />
                                        </span>
                                        <span className={cn('pl-2 col-11 pr-0')}>
                                            {i.note || i.comment}
                                        </span>
                                    </div>
                                )}
                            </div>
                    </div>
                );
            })
        ) : (
            <div className="h-100 fs-20 row mx-0 align-items-center od-text-secondary text-secondary justify-content-center">
                {CUSTOM_MESSAGES().NO_ITEM_FOUND}
            </div>
        );
    };

    const loyaltyTile = (items) => {

        const loyaltyData = tableData.seats.find((e) => e.id === items[0]?.seats[0]?.seatId);
        return (
            <div>
                {loyaltyData?.loyalty && (
                    <div
                        className={cn(
                            "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex justify-content-between"
                        )}
                        style={{
                            background: serverAppTheme?.itemsBg,
                            borderRadius: "4px",
                            color: serverAppTheme?.primary_text
                        }}
                    >
                        <div className="d-flex justify-content-start col-10 px-0">{LABEL().SBS_LOYALTY} {loyaltyData?.loyalty?.displayAccountNumber && `(${FormatLoyaltyPhoneNumber(loyaltyData?.loyalty?.displayAccountNumber)})`}</div>
                        <div className="d-flex justify-content-end align-items-center"><SuccessIcon /></div>
                    </div>
                )}
            </div>
        );
    };

    const offerTile = (items) => {
        const offerData = tableData.seats.find((e) => e.id === items[0]?.seats[0]?.seatId);
        return (
            <div>
                {offerData?.offer && (
                    <div
                        className={cn(
                            "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex justify-content-between"
                        )}
                        style={{
                            background: serverAppTheme?.itemsBg,
                            borderRadius: "4px",
                            color: serverAppTheme?.primary_text
                        }}
                    >
                        <div className="d-flex justify-content-start">
                            {offerData?.offer?.name
                                ? `${offerData.offer.name.slice(0, 18)}...`
                                : ''}
                        </div>
                        <div className="d-flex justify-content-end"><SuccessIcon /></div>
                    </div>
                )}
            </div>
        );
    };

    const renameStage = (data, isDelete) => {

        if (!isDelete) {

            const previousSeatObj = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), {});

            previousSeatObj?.splits?.map(el => {
                if (el?.id === isEditModalOpen?.seatId) {
                    el.name = data
                }
                // return el
            })

            props.setSeat(previousSeatObj);
            setIsEditModalOpen({ isEditOpen: false, data: {} });
        }
        else {
            removeWithPaymentStages(isEditModalOpen?.data);

            setIsEditModalOpen({ isDeleteOpen: false, data: {} });
        }
    }

    let isCheck = tableData?.splits?.[selectedStage]?.items?.every(el => el.isCheck);
    return (
        <div className="col-12 px-0 h-100 position-relative">
            <TouchableDiv
                className={cn(
                    "px-0 position-absolute d-flex justify-content-center align-items-center rounded",
                    style.backIcon,
                    style.zIndex100,
                )}
                style={{ backgroundColor: serverAppTheme.iconcolor_bg_box }}
                tabIndex="0"
                role="button"
                onClick={() => {
                    handleBackButtonClick();
                    setTableData({
                        splits: {},
                        seats: [],
                        stageItemsArray: []
                    });
                    setSelectedStage(null);
                }}
            >
                <BackChevron fill={serverAppTheme?.iconcolor} />
            </TouchableDiv>
            <div className={cn("col-12 pr-0 d-flex  fw-600", style.pl32, isOrderingPortrait ? 'h-4 ' : 'h-7 ')}>
                <div className="col-3 pl-1 fs_16 pr-0 d-flex align-items-center">
                    {LABEL().TABLE}{" "}
                    {(seat?.stationName?.length > 8
                        ? seat?.stationName.substring(0, 9) + "..."
                        : seat?.stationName) ||
                        (seat?.name?.length > 8
                            ? seat?.name.substring(0, 9) + "..."
                            : seat?.name) ||
                        seat?.stationNumber}
                </div>
                <div className={cn("col-6 px-0 text-center",isOrderingPortrait ? 'fs_18' :'fs_16')}>{LABEL().LS_SPLIT_BY_SEATS}</div>
                <div className="col-3 px-0 fs_16 text-right">#{seat?.number}</div>
            </div>
            <div className="col-12 row mx-0 px-0 pt-2 pb-12 h-97">
                <div
                    className={cn("px-0 px-2 pt-2 h-100 rounded",isOrderingPortrait ? 'col-6' : 'col-8')}
                    style={{ backgroundColor: serverAppTheme?.selector_control_color }}
                >
                    <div className={cn("col-12 px-0 row mx-0", isOrderingPortrait ? 'pb-25' : 'py-2')}> 
                   
                         <div className={cn("col-12 px-0 d-flex")}>                      
                                  <div className={cn("pl-0 pr-1" ,isOrderingPortrait ? 'col-4' : 'col-3')}>
                                    <TouchableButton
                                      type="button"
                                      className={cn(
                                        style.btnAddStyle,
                                        "btn-secondary btn-ripple text-center w-100 rounded",
                                        isOrderingPortrait ? 'fs_12' : 'fs_16'
                                      )}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleOpenEditModal();
                                      }}
                                    //   style={{ backgroundColor: serverAppTheme?.secondaryBtn,
                                    //     }}
                                      aria-label="plusBtn"
                                      rippleEffect={true}
                                    >
                                      {LABEL().ADD}
                                    </TouchableButton>
                                  </div>
                                  <div className={cn("pl-0 pr-1",isOrderingPortrait ? 'col-5' : 'col-3')}>
                                    <TouchableButton
                                      type="button"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleOpenDeleteModal();
                                      }} className={cn(
                                        style.btnDelStyle,
                                        "btn-ripple text-center rounded color-white w-100",
                                        isOrderingPortrait ? 'fs_12' : 'fs_16'
                                      )}
                                      style={{ backgroundColor: serverAppTheme?.primaryBtn }}
                                      rippleEffect={true}
                                    >
                                     {LABEL().SPLIT_BUTTON_DELETE}
                                    </TouchableButton>
                                  </div>
                                  <div className={cn("d-flex justify-content-end px-0",isOrderingPortrait ? 'col-3' : 'col-6')}>
                                    <TouchableButton
                                      type="button"
                                      className={cn("btn-ripple " ,isOrderingPortrait ? 'w-75' : 'w-30')}
                                      onClick={(event) => {
                                        event.preventDefault();
                                        handlePayment(true);
                                      }}
                                      style={{
                                        color: serverAppTheme?.btn_font_color,
                                        backgroundColor: serverAppTheme?.primaryBtn,
                                        borderRadius: "4px",
                                        border: "none",
                                        fontSize: isOrderingPortrait ? "12px" : "16px",
                                        fontWeight: "500",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      rippleEffect={true}
                                    >
                                      {LABEL().SAVE}
                                    </TouchableButton>
                                  </div>
                        
                                </div>                 
                    </div>
                    <div style={{overflowX: "hidden"}} className="col-12 px-0 h-88 overflowY rounded">
                        <div className={cn("col-12 px-0 h-auto", isOrderingPortrait  ? style.portraitGridcontainer : style.gridContainer)}>
                            {tableData?.splits &&
                                Object.values(tableData?.splits).map((item, index) => {
                                    return (
                                        Number(item.status) === 0 && (
                                            <TouchableDiv
                                                className="col-12 p-2 fs_16 fw-500 rounded"
                                                style={{
                                                    maxHeight: "113px",
                                                    backgroundColor:
                                                        selectedStage === item.id
                                                            ? serverAppTheme?.selected
                                                            : serverAppTheme?.splitUnselectedTile,
                                                    outline: 'none'
                                                }}
                                                tabIndex="0"
                                                role="button"
                                                onClick={() => handleStageSelection(item)}
                                            >
                                                <div className="col-12 px-0 d-flex">
                                                    <div className="col-10 px-0 pb-2">
                                                        {item?.name?.length > 0 ? (
                                                            <span>
                                                                Check: {index + 1}{" "}
                                                                {item?.name?.length > 5
                                                                    ? item?.name?.substring(0, 5)?.concat("...")
                                                                    : item?.name}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {LABEL().SBS_CHECK}: {index + 1}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="col-2 py-0 px-0 d-flex justify-content-end">
                                                        <TouchableButton
                                                            className={cn("rounded d-flex justify-content-center align-items-center" ,isOrderingPortrait ? style.checkDelStyle : 'h-80')}
                                                            style={{
                                                                backgroundColor:
                                                                    serverAppTheme?.mod_group_name_bg,
                                                                border: serverAppTheme?.select_border,
                                                            }}
                                                            onClick={(event) => { event.preventDefault(); setIsEditModalOpen({ isEditOpen: true, data: item, seatId: item?.id }) }}
                                                            rippleEffect={true}
                                                        >
                                                            <Edit
                                                                fill={serverAppTheme?.iconcolor}
                                                                width={"12px"}
                                                            />
                                                        </TouchableButton>
                                                    </div>
                                                </div>
                                                <div className="col-12 px-0 pb-2 d-flex">
                                                <span className='mr-1'>Seat: </span>
                                                    {item?.seats?.map((data) => {
                                                        const seat = tableData?.seats?.find(
                                                            (e) => e.id === data.seatId,
                                                        );
                                                        return (
                                                            seat && (
                                                                <div
                                                                    className={cn(
                                                                        "col-12 px-0 d-flex justify-content-right align-items-center rounded",
                                                                    )}
                                                                    key={data.id}

                                                                >
                                                                     {seat.name ? (
                                                                            <span className={cn('m-0 p-0')}>
                                                                                {seat.name}({seat.number})
                                                                            </span>
                                                                        ) : seat.number}
                                                                </div>
                                                            )
                                                        );
                                                    })}
                                                </div>
                                                <div className="row mx-0 col-12 px-0 fw-500">
                                                                    <div className="col-10 px-0">
                                                                      {item.totalAmount != null
                                                                        ? `${LABEL().CURRENCY_SYMBOL}${Number(item.totalAmount).toFixed(2)}`
                                                                        : ""}
                                                                    </div>
                                                                    <div className="d-flex justify-content-end col-2 px-0">
                                              
                                                                      <div>
                                                                        <TouchableButton
                                                                          type="button"
                                                                          className={cn(
                                                                            style.checkDelStyle,
                                                                            "col fs-20  btn-ripple  text-center py-0 px-0 rounded",
                                                                          )}
                                                                          style={{
                                                                            backgroundColor:
                                                                              serverAppTheme?.mod_group_name_bg,
                                                                            border: serverAppTheme?.select_border,
                                                                          }}
                                                                          onClick={(e) => {
                                                                            e.preventDefault();
                                                                            removeWithPaymentStages(item);
                                                                          }}
                                                                          rippleEffect={true}
                                                                        >
                                                                          <DeleteIcon
                                                                            fill={serverAppTheme?.iconcolor}
                                                                            width={"12px"}
                                                                          />
                                                                        </TouchableButton>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                            </TouchableDiv>
                                        )
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <div className={cn("px-0 h-100 pl-2 pr-0", isOrderingPortrait ? 'col-6' : 'col-4')}>
                    <div className="col-12 px-0 h-100">
                        <div className={cn("col-12 px-2  align-items-center row mx-0 fs_14 fw-500",isOrderingPortrait ? 'h-3' : 'h-5')} style={{ color: serverAppTheme?.secondary_text }}>
                            <TouchableDiv className="col-1 px-0 h-100 d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    className={cn(isOrderingPortrait ? style.portaritcheckbox : style.checkbox)}
                                    onClick={(e) => { e.stopPropagation(); handleCheckAllItems(e.target.checked) }}
                                    style={{
                                        border: isCheck ? "none" : serverAppTheme?.checkbox_border,
                                        "--checkbox-checked-color":
                                            serverAppTheme?.checkbox_check_color,
                                        '--checkbox-checked-bg': serverAppTheme?.checkbox_checked
                                    }}
                                    checked={isCheck}
                                />
                            </TouchableDiv>
                            <div className={cn("col-6 pl-2 pr-0",isOrderingPortrait ? 'fs-12' : '')}>{LABEL().ITEMS}</div>
                            <div className={cn("col-2 px-0 text-center",isOrderingPortrait ? 'fs-12' : '')}>{LABEL().QTY}</div>
                            <div className={cn("col-3 px-0 text-right",isOrderingPortrait ? 'fs-12' : '')}>{LABEL().AMOUNT}</div>
                        </div>
                        <div
                            className={cn(
                                "col-12 px-0 pt-1 pb-2", !selectedStage ? 'h-82' : 'h-70'
                            )}
                        >
                            <div className="w-100 h-100 overflowY">
                                {tableData?.splits && tableData?.splits[selectedStage] ? (
                                    <>
                                        {ItemList(tableData?.splits[selectedStage]?.items)}
                                        {loyaltyTile(tableData?.splits[selectedStage]?.items)}
                                        {offerTile(tableData?.splits[selectedStage]?.items)}
                                    </>
                                ) : (
                                    <div className="col-12 h-100 row mx-0 align-items-center text-center fs-18" style={{ color: serverAppTheme?.secondary_btn_disable_text }}>
                                        {CUSTOM_MESSAGES().PLEASE_SELECT_A_STAGE_TO_SEE_ITEMS}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={cn( isOrderingPortrait ? `${style.btncontainer} col-12 px-0` : '')}>
                        {tableData?.splits?.[selectedStage]?.totalAmount != null && (
                            <div className={cn("col-12 py-2   fs_18 fw-600 d-flex justify-content-between",isOrderingPortrait ? 'px-2 mb-12' : 'px-3 mb-2 ')} style={newItemsStyle.sentItemsStyle}>
                                <div className="fs_16 fw-600">{LABEL().TOTAL}:</div>
                                <div className="fs_16 fw-600">{currencySymbol}{Number(tableData?.splits[selectedStage]?.totalAmount).toFixed(2)}</div>
                            </div>
                        )}
                        <div className={cn("col-12 h-50",isOrderingPortrait ? 'px-0' : 'px-3')}>
                            <div className={cn(!isOrderingPortrait ? "row h-25" : '')}>
                                <div className={cn(isOrderingPortrait ? 'col-12 px-0 pb-12' : 'col-6 pr-2 pl-0')}>
                                    <TouchableButton
                                        type="button"
                                        className={cn("w-100 rounded border-0", isOrderingPortrait ? style.moveBtnPortrait : `${style.moveBtn}`)}
                                        style={{ backgroundColor: !shwMove() ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.primaryBtn, color: !shwMove() ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                                        disabled={!shwMove()}
                                        onClick={(e) => { e.preventDefault(); handleStageMove("splitBySeat") }}
                                    >
                                        {LABEL().MOVE}
                                    </TouchableButton>
                                </div>

                                <div
                                    className={cn("px-0", isOrderingPortrait ? 'col-12' : 'col-6')}
                                >
                                    <TouchableButton
                                        type="button"
                                        className={cn("w-100 rounded  border-0", isOrderingPortrait ? style.paybtnPortrait : `${style.payBtn}`)}
                                        style={{ backgroundColor: serverAppTheme?.enabledPayBtn , color:serverAppTheme?.btn_font_color}}
                                        onClick={(event) => { event.preventDefault(); handlePayment() }}
                                        rippleEffect={true}
                                    >
                                        {LABEL().PAY}

                                    </TouchableButton>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {isEditModalOpen.isEditOpen &&
                <FullWidthModal
                    isOpen={isEditModalOpen.isEditOpen}
                    noBackground
                    customClass2={cn("w-100 h-100 position-relative")}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                        pointerEvents: "auto",
                        backgroundColor: serverAppTheme?.popUp_bg,
                        backgroundClip: "padding-box",
                        border: "0",
                        boxShadow: serverAppTheme?.popUp_box_shadow,
                    }}
                >
                    <div className="col-12 px-0 h-100 justify-content-center align-items-center position-relative text-center">
                        <ModalHeader
                            isTab={seat?.tab}
                            stationName={seat?.stationName}
                            tileHeader={LABEL().CHECK_NAME}
                            seatNumber={seat?.number}
                        />
                        <div
                            className="text-right"
                            style={{ position: "absolute", top: "10px", right: "10px", zIndex: "999" }}
                        >
                        </div>
                        {isEditModalOpen.isEditOpen && (
                            <KeyboardForOrder
                                name="stageName"
                                type="textDefaultCaps"
                                customClass="mt-2"
                                specialValue={isEditModalOpen?.data?.name ? String(isEditModalOpen?.data?.name) : ''}
                                placeholder={CUSTOM_MESSAGES().ENTER_CHECK_NAME}
                                buttonName={LABEL().SUBMIT}
                                onSubmit={renameStage}
                                editSeatPopUP={true}
                                noBtnclass={true}
                                serverAppTheme={serverAppTheme}
                                cancelBtnName={LABEL().CANCEL}
                                onclose={() => setIsEditModalOpen(false)}
                                header={LABEL().CHECK_NAME}
                                setErrorPopUp={props.setErrorPopUp}
                            />
                        )}
                    </div>
                </FullWidthModal>}
        </div>
    );
};

const mapStateToProps = ({
    orders,
    oauth,
}) => ({
    deviceInfo: oauth.deviceInformation,
    userInfo: oauth.loggedInUserData,
    auth: oauth.authInfo,
    seat: orders.seats,
    position: orders.position,
    menuItemsHashTable: orders.menuItemsHashTable,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setNotification,
    setSeat,
    removeWithPaymentStages,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(SplitBySeat);
